<template>
  <organizations-table :view="view"/>
</template>

<script>
import { mapState } from 'vuex'
import organizationsTable from './table'

export default {
  components: {
    organizationsTable
  },
  computed: {
    ...mapState('tenants', {
      view: '_defaultView'
    })
  }
}
</script>



// WEBPACK FOOTER //
// src/components/pages/admin/organizations/all.vue